module.exports = __webpack_public_path__ + "img/feature-12.2fbe54ee.jpg";